// Entry point for the build script in your package.json
import "./add_jquery"
import "./add_jquery_ui"
import "./add_select2"
import "./add_datatables"
import './add_bootstrap'
import './add_sortable'
import "@hotwired/turbo-rails"
import "trix"
import "@rails/actiontext"
import "./controllers"
import './sortable_tables'
import "./add_highcharts"
import "./bootstrap_tabs_fix"
import "./job_costs"

const VALID_POPPER_PLACEMENTS = new Set([
    "auto",
    "auto-start",
    "auto-end",
    "top",
    "top-start",
    "top-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "right",
    "right-start",
    "right-end",
    "left",
    "left-start",
    "left-end"
])

function normalizePopperPlacement(value, fallback = "bottom") {
    if (typeof value !== "string") return fallback
    const normalized = value.trim()
    if (normalized.length === 0) return fallback
    return VALID_POPPER_PLACEMENTS.has(normalized) ? normalized : fallback
}

function sanitizePopperConfig(config, fallbackPlacement) {
    const normalizedConfig = (config && typeof config === "object") ? { ...config } : {}
    normalizedConfig.placement = normalizePopperPlacement(normalizedConfig.placement, fallbackPlacement)

    if (Array.isArray(normalizedConfig.modifiers)) {
        normalizedConfig.modifiers = normalizedConfig.modifiers.map(modifier => {
            if (!modifier || typeof modifier !== "object") return modifier
            if (modifier.name !== "offset") return modifier

            const offset = modifier.options?.offset
            if (Array.isArray(offset) || typeof offset === "function") return modifier

            return {
                ...modifier,
                options: {
                    ...(modifier.options || {}),
                    offset: [0, 2]
                }
            }
        })
    }

    return normalizedConfig
}

function hardenBootstrapPopperPlacement() {
    const bs = window.bootstrap
    if (!bs) return

    const patchGetPopperConfig = (Ctor, fallbackPlacement, options = {}) => {
        if (!Ctor || !Ctor.prototype || typeof Ctor.prototype._getPopperConfig !== "function") return
        if (Ctor.prototype.__placementPatched === true) return

        const original = Ctor.prototype._getPopperConfig
        Ctor.prototype._getPopperConfig = function (...args) {
            const config = original.apply(this, args) || {}
            return sanitizePopperConfig(config, fallbackPlacement)
        }

        const shouldPatchCreatePopper = options.patchCreatePopper === true
        if (shouldPatchCreatePopper && typeof Ctor.prototype._createPopper === "function" && Ctor.prototype.__createPopperPlacementPatched !== true) {
            const originalCreatePopper = Ctor.prototype._createPopper
            Ctor.prototype._createPopper = function (...args) {
                try {
                    return originalCreatePopper.apply(this, args)
                } catch (error) {
                    if (!String(error?.message || "").includes("placement.split")) throw error

                    const fallbackGetPopperConfig = this._getPopperConfig
                    this._getPopperConfig = (...configArgs) => sanitizePopperConfig(
                        fallbackGetPopperConfig.apply(this, configArgs),
                        fallbackPlacement
                    )

                    try {
                        return originalCreatePopper.apply(this, args)
                    } finally {
                        this._getPopperConfig = fallbackGetPopperConfig
                    }
                }
            }
            Ctor.prototype.__createPopperPlacementPatched = true
        }

        Ctor.prototype.__placementPatched = true
    }

    patchGetPopperConfig(bs.Dropdown, "bottom-start", { patchCreatePopper: true })
    patchGetPopperConfig(bs.Tooltip, "top", { patchCreatePopper: true })
    patchGetPopperConfig(bs.Popover, "right", { patchCreatePopper: true })
}

hardenBootstrapPopperPlacement()

// `_getPopperConfig` sanitizes placement synchronously, and the
// `_createPopper` try/catch above recovers if Popper throws during
// construction. Popper's `forceUpdate` promise can still surface a
// `placement.split is not a function` error asynchronously when a Popper
// instance is disposed / re-configured mid-update (dropdown close + open
// during a Turbo navigation, etc.) — that path is unreachable from Bootstrap's
// own catch. Swallow that specific rejection so the console stays clean and
// the promise chain does not crash unrelated JS.
function isPopperPlacementError(reason) {
    const message = reason && typeof reason === "object" ? String(reason.message || "") : String(reason || "")
    return message.includes("placement.split is not a function")
}

window.addEventListener("unhandledrejection", (event) => {
    if (isPopperPlacementError(event.reason)) event.preventDefault()
})

window.addEventListener("error", (event) => {
    if (isPopperPlacementError(event.error) || isPopperPlacementError(event.message)) {
        event.preventDefault()
        return false
    }
    return undefined
})

document.addEventListener('turbo:load', () => {
    // Dropdowns
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(el => {
        try {
            window.bootstrap.Dropdown.getOrCreateInstance(el)
        } catch (error) {
            console.warn("Skipping invalid dropdown toggle", error)
        }
    })

    // Popovers
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
        try {
            const rawPlacement = (el.getAttribute('data-bs-placement') || 'top').toString()
            const placement = normalizePopperPlacement(rawPlacement, 'top')
            window.bootstrap.Popover.getOrCreateInstance(el, { placement })
        } catch (error) {
            console.warn("Skipping invalid popover toggle", error)
        }
    })
})

document.addEventListener('turbo:before-stream-render', function () {



    $(".alert" ).fadeOut(3000);



});


document.addEventListener('turbo:after-stream-render', function () {



});

document.addEventListener('turbo:frame-render', function () {


    $(".alert" ).fadeOut(3000);



});

document.addEventListener("turbo:submit-end", (event) => {
    const form = event.target
    if (!(form instanceof HTMLFormElement)) return
    if (!form.classList.contains("ai-room-form")) return

    if (event.detail?.success) {
        const modalElement = form.closest(".modal")
        if (modalElement && window.bootstrap?.Modal) {
            window.bootstrap.Modal.getOrCreateInstance(modalElement).hide()
        }
    }
})
